import { createSlice } from '@reduxjs/toolkit';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { helper } from 'src/utils/helper';

export class TopluSonucGosterRequest {
    basTarih: string = helper.datetimeToday();
    bitTarih: string = helper.datetimeToday();
    islemDurum: number = 1;
    personelId: number;
    servisId: number;
    doktorId: number;
    hastaAdSoyad: string = "";
}
export interface IKDHastaKayitState {
    topluSonucGosterRequest?: TopluSonucGosterRequest;
    searchClick: boolean;
}

const KDHastaKayitSlice = createSlice<
    IKDHastaKayitState,
    MapReducerPayloads<
        IKDHastaKayitState,
        {
            settopluSonucGosterRequest: TopluSonucGosterRequest;
            setSearchClick: boolean;
        }
    >
>({
    name: 'kdHastaKayitState',
    initialState: {
        topluSonucGosterRequest: new TopluSonucGosterRequest(),
        searchClick: false
    },
    reducers: {
        settopluSonucGosterRequest: (state, action) => {
            state.topluSonucGosterRequest = action.payload;
        },
        setSearchClick: (state, action) => {
            state.searchClick = action.payload;
        }
    }
});
export default KDHastaKayitSlice;
